import {
    SEND_INVOICE,
    SEND_INVOICE_SUCCESS,
    SEND_INVOICE_FAILURE,
    RESET_INVOICE,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
};

const SendInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_INVOICE:
            return {
                ...state,
                loading: true,
            };
        case SEND_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.data,
            };
        case SEND_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case RESET_INVOICE:
            return {
                ...state,
                statusCode: '',
                statusMessage: '',
            };
        default:
            return {
                ...state,
            };
    }
};

export default SendInvoiceReducer;
